import React from 'react'
import styled from 'styled-components'
import { deleteMessage } from '../../api/firebase'
const Wrapper = styled.div`

    border-top: 1px solid black;
    border-bottom: 1px solid black;
    padding: 20px;
    width: 80%;

    display: flex;
    flex-direction: column;
    header { 
        display: grid;
        grid-template-columns: 1fr 100px;
    }
    h3{
        font-size: 18px;
        width: 100%;
        text-align: left;
    }
    span{
        display: block;
        color: #333;
        font-size: 14px;
    }
    p{

    }
    a{
        text-decoration: none;
        color: #0040ff;
        transition: all 0.3s ease-in;
        &:hover{
            text-decoration: underline dotted ;
        }
    }

`
const Message = ({id,from,mailto,message,sent,subject}) => {
  return (
    <Wrapper>
        <header>
            <h3>{subject}</h3>
            <button style={{
                display: 'block',
                borderRadius: '10px',
                height: "auto", 
                fontSize: "14px"
                }} onClick={()=>deleteMessage(id)}>Delete</button>

        </header>
        <span>From {from} at {sent} </span>
        <p>{message}</p>
        <a href={`mailto:${mailto}`}>Respond</a>
    </Wrapper>    
  )
}

export default Message